import React from "react";
import { Link } from "react-router-dom";

const OrderSuccess = () => {
  return (
    <div style={{ padding: "48px", textAlign: "center" }}>
      <h2>Thank you! Your order is confirmed.</h2>
      <p>We have received your payment and are preparing your shipment.</p>
      <Link to="/">Back to home</Link>
    </div>
  );
};

export default OrderSuccess;


